var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_313939727749822935329601518363310986608",
    x1: "50%",
    x2: "50%",
    y1: "32.846%",
    y2: "90.794%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "hinava_random_uuid_149231210176247818804585381291946351342",
    d: "M12.32.037c.403 0 .796.122 1.128.349l10.195 6.963c.912.623 1.147 1.868.524 2.78-.14.205-.318.383-.524.523l-10.195 6.962c-.912.623-2.157.389-2.78-.523-.226-.333-.348-.726-.348-1.128v-.875l5.434-4.179c.092-.07.177-.148.255-.233l.111-.133c.674-.875.51-2.13-.365-2.804l-5.435-4.18V2.036c0-1.104.896-2 2-2zm-9.838 0c.403 0 .796.122 1.128.349l10.195 6.963c.912.623 1.146 1.868.523 2.78-.14.205-.318.383-.523.523L3.61 17.614c-.912.623-2.157.389-2.78-.523-.227-.333-.348-.726-.348-1.128V2.037c0-1.104.895-2 2-2z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-64 -346) translate(48 338) translate(16 8) translate(3.94 6.675)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hinava_random_uuid_28870512023512080911827371069727457778",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hinava_random_uuid_149231210176247818804585381291946351342"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "url(#hinava_random_uuid_313939727749822935329601518363310986608)",
    mask: "url(#hinava_random_uuid_28870512023512080911827371069727457778)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 549.545,
    height: 269.517,
    rx: 8,
    transform: "translate(-261.273 -157.342)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackward);
export default __webpack_public_path__ + "static/media/backward.ed3612483b62fda717a292be98279bdc.svg";
export { ForwardRef as ReactComponent };